const PROD_API = "https://api4.dealhawkpro.io";
const DEV_API = "http://localhost:8003";

export function affiliateRefFromSearch(search: string): string | null {
  const params = new URLSearchParams(search);
  return params.get("ref") || params.get("via");
}

export function isMobileUserAgent(ua = navigator.userAgent): boolean {
  return /iphone|ipod|ipad|android|mobile/i.test(ua);
}

export function mobileInstallApiUrl(): string {
  const host = window.location.hostname;
  const isDev =
    host === "localhost" || host === "127.0.0.1" || host.endsWith(".local");
  return isDev ? DEV_API : PROD_API;
}

export function shouldAffiliateMobileInstallRedirect(
  search = window.location.search,
  ua = navigator.userAgent
): boolean {
  return !!affiliateRefFromSearch(search) && isMobileUserAgent(ua);
}

export function redirectToMobileInstall(
  search = window.location.search,
  referrerDomain?: string,
  attribution: Record<string, string> = {},
): void {
  const params = new URLSearchParams(search);
  if (referrerDomain?.trim()) {
    params.set("referrer_domain", referrerDomain.trim());
  }
  // Stored first-touch attribution fills gaps only; anything on this URL wins.
  for (const [key, value] of Object.entries(attribution)) {
    if (value && !params.has(key)) params.set(key, value);
  }
  const query = params.toString();
  window.location.replace(
    `${mobileInstallApiUrl()}/install${query ? `?${query}` : ""}`
  );
}
